import { useEffect, useState } from 'react';

/**
 * `value`, once it has stopped changing for `ms` milliseconds. For views that follow typing - a
 * design preview, a post preview - so they keep up without redrawing on every keystroke.
 *
 * A change of `resetKey` takes `value` at once instead: when the source is replaced wholesale (a
 * form filled from a loaded record), waiting would only show what it replaced.
 */
export function useDebounced<T>(value: T, ms: number, resetKey?: string | number | null): T {
  const [settled, setSettled] = useState(value);
  const [settledKey, setSettledKey] = useState(resetKey);
  if (!Object.is(settledKey, resetKey)) {
    // Set during render, so React redraws with it before anything is shown.
    setSettledKey(resetKey);
    setSettled(value);
  }
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return settled;
}
